import { authIa } from "@/lib/firebase";
import { signInWithCustomToken } from "firebase/auth";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import AuthContainer from "@/ui/Auth/AuthContainer";
import { Heading, Text, VStack } from "@chakra-ui/react";

const CustomTokenHandler = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const handleCustomTokenAuth = async () => {
      try {
        const token = new URLSearchParams(window.location.search).get("token");

        if (!token) {
          console.error("No token found in URL");
          navigate("/");
          return;
        }

        await signInWithCustomToken(authIa, token);

        navigate("/", { replace: true });
      } catch (error) {
        console.error("Error during custom token authentication:", error);
        navigate("/");
      }
    };

    handleCustomTokenAuth();
  }, [navigate]);

  return (
    <AuthContainer>
      <VStack spacing={6} align="center" justify="center" minH="50vh">
        <Heading
          color="white"
          size="xl"
          textAlign="center"
          sx={{ textWrap: "balance" }}
        >
          {t(
            "auth.redirect.title",
            "Vous allez être redirigé dans un instant..."
          )}
        </Heading>
        <Text color="white" fontSize="lg" textAlign="center" opacity={0.8}>
          {t(
            "auth.redirect.subtitle",
            "Veuillez patienter pendant que nous finalisons votre connexion."
          )}
        </Text>
      </VStack>
    </AuthContainer>
  );
};

export default CustomTokenHandler;
